// 位置
import { useLazyQuery, useQuery } from "@apollo/react-hooks"
import { useEffect, useMemo } from "react"
import { AdPlace } from "Types/place"
import { tableInitialVariables } from "Methods/table"
import { WeixinPlaces } from "Methods/place"
import { generateQuery } from "Methods/query"
import { CalendarType } from "Types/channel"

const adPlaceQuery = generateQuery("ad_place", "channel { name }")
export function useFetchAdPlaces(channelName: string) {
    const { data: adPlaceData } = useQuery(adPlaceQuery, {
        variables: {
            ...tableInitialVariables,
            limit: 1000,
            where: {
                channel: {
                    name: {
                        _eq: channelName,
                    },
                },
            },
            order_by: {
                seq_num: "asc",
            },
        },
    })
    const { ad_place: places = [] } = adPlaceData || {}
    if (channelName === "微信" && places.length > 1) {
        return {
            places: WeixinPlaces.map((d: any) => (
                { ...d, channel_id: places[0].channel_id }
            ))
        }
    }

    if (['童学馆', '果壳视频', '摄影', '美丽', '果壳自然', '吃货', '果壳病人'].includes(channelName) && places.length > 1) {
        return {
            places: places.map(({ id, ...d }: any) => (
                { ...d, _id: id, id: d.seq_num }
            ))
        }
    }

    return { places }
}

export function useMaterialFetchAdPlaces(channelName: string) {
    const { data: adPlaceData } = useQuery(adPlaceQuery, {
        variables: {
            ...tableInitialVariables,
            limit: 1000,
            where: {
                channel: {
                    name: {
                        _eq: channelName,
                    },
                },
            },
            order_by: {
                seq_num: "asc",
            },
        },
    })
    const { ad_place: places = [] } = adPlaceData || {}
    if (channelName === "微信" && places.length > 1) {
        return {
            places: WeixinPlaces.map((d: any) => (
                { ...d, channel_id: places[0].channel_id }
            ))
        }
    }

    return { places }
}

export function useExportFetchAdPlaces(channelName: string) {
    const { data: adPlaceData } = useQuery(adPlaceQuery, {
        variables: {
            ...tableInitialVariables,
            limit: 1000,
            where: {
                channel: {
                    name: {
                        _eq: channelName,
                    },
                },
            },
            order_by: {
                seq_num: "asc",
            },
        },
    })
    const { ad_place: places = [] } = adPlaceData || {}

    return { places }
}
// 获取渠道
export function useFetchGroupAdPlace(isTrueEditor = false) {
    const adPlaceQuery = generateQuery("ad_place", "channel { name }")
    const { data } = useQuery(adPlaceQuery, {
        variables: {
            ...tableInitialVariables,
            limit: 1000,
        },
    })
    const { ad_place = [] } = data || {}
    const channels = useMemo(() => {
        const channels: {
            [key: number]: {
                name: string,
                places: AdPlace[],
            },
        } = {}
        for (const place of ad_place) {
            const key: number = place.channel_id
            if (isTrueEditor && place.channel.name !== "微信" && place.channel.name !== "微博" && place.channel.name !== "果壳自然" && place.channel.name !== "果壳病人") {
                continue
            }

            if (!channels.hasOwnProperty(key)) {
                channels[key] = {
                    name: place.channel.name,
                    places: [place],
                }
            } else {
                channels[key].places.push(place)
            }
        }
        return channels
    }, [ad_place, isTrueEditor])
    return {
        channels,
    }
}
/*
   获取日历的广告位
   支持pc，移动站点，app，微信，微博，母版
   用来替换useFetchAdPlaces方法
 */
export function useFetchPlaces(calendarType: CalendarType) {
    const needFetch = calendarType !== "preset" && calendarType !== "wechat"
    const [fetchData, { data }] = useLazyQuery(adPlaceQuery, {
        variables: {
            ...tableInitialVariables, limit: 1000,
            where: {
                channel: {
                    type_name: { _eq: calendarType },
                },
            },
            order_by: { seq_num: "asc" },
        },
    })
    useEffect(() => {
        if (needFetch) {
            fetchData()
        }
        // eslint-disable-next-line
    }, [calendarType])
    const { ad_place = [] } = data || {}
    if (needFetch) {
        return { places: ad_place }
    } else {
        return {
            places: WeixinPlaces.map((d) => (
                { ...d }
            ))
        }
    }
}
